module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-top-panel-1-c8a550afb69eefa9ccc685250008d91d.svg";